export enum ApiErrorEnum {
  AntiCaptureActivated = 'ANTICAPTURE_ACTIVATED',
  DownloadRestrictionActivated = 'DOWNLOAD_RESTRICTION_ACTIVATED',
}
